import { COMMERCIAL_CORE_APPS_ID, CONSUMER_CORE_APPS_ID, } from '@office-start/app-gallery-types';
import { AuthType } from '@office-start/auth-types';
import { OfficeRouteItemType } from '@office-start/officehome-types';
import { Referral, } from '@office-start/telemetry-types';
// File to consolidate apps module logic as its shared between two items
var appBarPinningCustomValidator = function (_a) {
    var _b;
    var identity = _a.identity, extraSequenceValidationData = _a.extraSequenceValidationData, featureGates = _a.featureGates;
    // make sure the user is not currently on the app pinning wizard gate
    if ((_b = featureGates.appPinningWizardGates) === null || _b === void 0 ? void 0 : _b.appPinningWizardEnabled) {
        return Promise.resolve(false);
    }
    // Make sure that the core apps will show up on the
    // Apps module page for the 'AppBar_Pinning_Callout`
    var coreApps = identity.authType === AuthType.MSA
        ? CONSUMER_CORE_APPS_ID
        : COMMERCIAL_CORE_APPS_ID;
    var workloadsPromise = extraSequenceValidationData.workloadsPromise;
    return workloadsPromise.then(function (workloads) {
        return coreApps.some(function (id) {
            return workloads.some(function (workload) { return workload.Id === id; });
        });
    });
};
var appBarPinningWizardCustomValidator = function (_a) {
    var extraSequenceValidationData = _a.extraSequenceValidationData, featureGates = _a.featureGates;
    // This check should align closely with the one in AppGalleryComponent, where we decide whether the Pinning Wizard should be shown
    return extraSequenceValidationData.appBarUserDataPromise.then(function (appBarUserData) {
        var _a, _b;
        var shouldShow = ((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.appPinningWizardGates) === null || _a === void 0 ? void 0 : _a.appPinningWizardEnabled) && // check for pinning wizard feature gate and user data
            ((_b = appBarUserData === null || appBarUserData === void 0 ? void 0 : appBarUserData.pinnedApps) === null || _b === void 0 ? void 0 : _b.every(function (pinnedApp) { return pinnedApp.pinSource !== 'UserPinned'; })); // check to make sure the user hasn't pinned any apps already
        return !!shouldShow;
    });
};
var appsModuleGates = function (gates) { var _a, _b; return (_b = (_a = gates.appsModuleGates) === null || _a === void 0 ? void 0 : _a.appsModuleEnabled) !== null && _b !== void 0 ? _b : false; };
var appPinningWizardGates = function (gates) { var _a, _b; return (_b = (_a = gates.appPinningWizardGates) === null || _a === void 0 ? void 0 : _a.appPinningWizardEnabled) !== null && _b !== void 0 ? _b : false; };
var appBarPinningGates = function (gates) {
    var _a, _b, _c;
    return (_c = (((_a = gates.appBarPinningGates) === null || _a === void 0 ? void 0 : _a.appBarPinningEnabled) &&
        ((_b = gates.appBarOverflowOnlyGates) === null || _b === void 0 ? void 0 : _b.appBarOverflowOnlyEnabled))) !== null && _c !== void 0 ? _c : false;
};
var adminAcquiredAppsGates = function (gates) { var _a, _b; return (_b = (_a = gates.adminAcquiredAppsGates) === null || _a === void 0 ? void 0 : _a.adminAcquiredAppsEnabled) !== null && _b !== void 0 ? _b : false; };
export var AdminAcquiredAppsCustomValidator = function (_a) {
    var extraSequenceValidationData = _a.extraSequenceValidationData, featureGates = _a.featureGates;
    return extraSequenceValidationData.adminAcquiredAppsPromise.then(function (adminAcquiredApps) {
        return hasNewAdminAcquiredApps(featureGates, adminAcquiredApps);
    });
};
var AppsModuleCustomValidator = function (_a) {
    var extraSequenceValidationData = _a.extraSequenceValidationData, featureGates = _a.featureGates;
    return extraSequenceValidationData.adminAcquiredAppsPromise.then(function (adminAcquiredApps) {
        return !hasNewAdminAcquiredApps(featureGates, adminAcquiredApps);
    });
};
var hasNewAdminAcquiredApps = function (featureGates, adminAcquiredApps) {
    return adminAcquiredAppsGates(featureGates) && adminAcquiredApps.length > 0;
};
var adminAcquiredAppsImpressionEvent = "Callout_Apps_Module_With_Privacy" /* KnownImpressionInstrumentationEvents.CalloutAppsModuleWithPrivacyImpression */;
var appsModuleImpressionEvent = "App_Pinning_Sequence" /* KnownImpressionInstrumentationEvents.AppPinningSequenceImpression */;
var appsModulePages = [
    'OfficeHome',
    'Pwa',
    'AppGallery',
];
var pinningWizardTuiPages = [
    'OfficeHome',
    'Pwa',
];
export var AppBarModuleAndPinningTuiGroup = {
    id: 'AppBar_AppsModulePinning_Group',
    type: 'group',
    activationSettings: {
        pages: appsModulePages,
        impressionEvents: [appsModuleImpressionEvent],
        featureGates: function (gates) {
            return appsModuleGates(gates) && appBarPinningGates(gates);
        },
        customValidator: appBarPinningCustomValidator,
    },
    impressionEvent: appsModuleImpressionEvent,
    callouts: ['AppBar_Module_Callout', 'AppBar_Pinning_Callout'],
};
export var AppPinningWizardTuiItem = {
    id: 'AppBar_AppsModule_PinningWizard',
    type: 'standalone',
    activationSettings: {
        pages: pinningWizardTuiPages,
        impressionEvents: [appsModuleImpressionEvent],
        featureGates: function (gates) {
            return appsModuleGates(gates) &&
                appBarPinningGates(gates) &&
                appPinningWizardGates(gates);
        },
        customValidator: appBarPinningWizardCustomValidator,
    },
    impressionEvent: appsModuleImpressionEvent,
    callout: 'App_PinningWizard_Callout',
    actionButton: {
        text: 'calloutActionButtonOpenAppsText',
        action: function (_a) {
            var navigateUrl = _a.navigateUrl;
            var param = {
                area: 'TuiCallout',
                eventName: 'OpenAppsClick',
                elementId: 'open-apps-button',
                referral: Referral.AppGallery,
                clickParams: {},
            };
            navigateUrl === null || navigateUrl === void 0 ? void 0 : navigateUrl({
                route: 'AppGallery',
                type: OfficeRouteItemType.Base,
            }, undefined, param);
        },
    },
    // We don't care about onDismiss here
};
export var AppsModuleTuiItem = {
    id: 'AppBar_AppsModule',
    type: 'item',
    activationSettings: {
        pages: appsModulePages,
        impressionEvents: [appsModuleImpressionEvent],
        featureGates: appsModuleGates,
        customValidator: AppsModuleCustomValidator,
    },
    impressionEvent: appsModuleImpressionEvent,
    callout: 'AppBar_Module_Callout',
};
// For new user sequence, user will see either 'AppsModuleTuiItem' or 'AppsModuleWithPrivacyTuiItem'
export var AppsModuleWithPrivacyTuiItem = {
    id: 'AppsModule_With_Privacy',
    type: 'item',
    activationSettings: {
        pages: appsModulePages,
        impressionEvents: [adminAcquiredAppsImpressionEvent],
        featureGates: function (gates) {
            return appsModuleGates(gates) && adminAcquiredAppsGates(gates);
        },
        customValidator: AdminAcquiredAppsCustomValidator,
    },
    impressionEvent: adminAcquiredAppsImpressionEvent,
    callout: 'AppBar_Module_With_Privacy_Callout',
};
//# sourceMappingURL=apps-module-sequence.js.map